<agpr-panel
    [header]="'Amplify.dialogs.newWire.distributionRegion.heading'"
    [toggleable]="false"
>
    <div
        class="agpr-wireRegionSelect-distributionRegion-container"
        role="radiogroup"
        [attr.aria-label]="'Amplify.dialogs.newWire.selectRegion.label' | localize"
    >
        <ng-container *ngFor="let wireQuota of quotas">
            <agpr-radio
                [id]="'wireRegionSelect_distributionRegion_' + wireQuota.region"
                name="region_select"
                [label]="'WireRegion.withCount.' + wireQuota.region | localize : {
                    count: wireQuota.baselineWires + wireQuota.additionalWires - wireQuota.usedWires
                }"
                [hiddenLabel]="'WireRegion.withCount.' + wireQuota.region | localize : {
                    count: wireQuota.baselineWires + wireQuota.additionalWires - wireQuota.usedWires
                }"
                [value]="wireQuota.region"
                [(ngModel)]="selectedRegion"
                (ngModelChange)="onRegionSelect($event);"
                ariaDescribedBy="region_disclaimer quota_warning"
            ></agpr-radio>
        </ng-container>
        <agpr-radio
            id="wireRegionSelect_distributionRegion_otherRegions"
            name="region_select"
            [label]="'WireRegion.withCount.otherRegions' | localize"
            [hiddenLabel]="'WireRegion.withCount.otherRegions' | localize"
            [value]="wireRegionEnum.other"
            [(ngModel)]="selectedRegion"
            (ngModelChange)="onRegionSelect($event)"
            ariaDescribedBy="other_disclaimer"
        ></agpr-radio>
    </div>
    <agpr-message
        id="region_disclaimer"
        *ngIf="(selectedRegion !== wireRegionEnum.other) && !showQuotaWarning"
        class="agpr-wireRegionSelect-distributionRegion-notice"
        [severity]="messageSeverities.info"
    >
        {{'Amplify.wire.publicationRegions.disclaimer1' | localize}}
        <span *ngIf="selectedRegion === wireRegionEnum.united_states">
            {{'Amplify.wire.publicationRegions.us' | localize}}
        </span>
        <span *ngIf="selectedRegion === wireRegionEnum.united_kingdom">
            {{'Amplify.wire.publicationRegions.uk' | localize}}
        </span>
        {{'Amplify.wire.publicationRegions.disclaimer2' | localize}}
    </agpr-message>
    <agpr-message
        id="quota_warning"
        *ngIf="(selectedRegion !== wireRegionEnum.other) && showQuotaWarning"
        class="agpr-wireRegionSelect-distributionRegion-notice"
        [severity]="messageSeverities.warning"
    >
        {{'Amplify.wire.publicationRegions.quotaWarning.disclaimer1' | localize}}
        <a
            href="https://www.agilitypr.com/newswire-3/"
            target="_blank"
        >
            {{'Amplify.wire.publicationRegions.contactLink' | localize}}
        </a>
        {{'Amplify.wire.publicationRegions.quotaWarning.disclaimer2' | localize}}
    </agpr-message>
    <agpr-message
        id="other_disclaimer"
        *ngIf="selectedRegion === wireRegionEnum.other"
        class="agpr-wireRegionSelect-distributionRegion-notice"
        [severity]="messageSeverities.warning"
    >
        {{'Amplify.wire.publicationRegions.others.disclaimer1' | localize}}
        <a
            href="https://www.agilitypr.com/newswire-provisioning-form"
            target="_blank"
        >
            {{'Amplify.wire.publicationRegions.others.contactLink' | localize}}
        </a>
        {{'Amplify.wire.publicationRegions.others.disclaimer2' | localize}}
    </agpr-message>
</agpr-panel>
